import { render, staticRenderFns } from "./ViewEntityModal.vue?vue&type=template&id=70f95283"
import script from "./ViewEntityModal.vue?vue&type=script&lang=js"
export * from "./ViewEntityModal.vue?vue&type=script&lang=js"
import style0 from "./ViewEntityModal.vue?vue&type=style&index=0&id=70f95283&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports